import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCog32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconCog32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M15.25 4a3 3 0 0 0-2.955 2.477q-.209.08-.413.167a3 3 0 0 0-3.837.34l-1.06 1.061a3 3 0 0 0-.34 3.837 10 10 0 0 0-.168.413A3 3 0 0 0 4 15.25v1.5a3 3 0 0 0 2.62 2.976q.055.134.117.266a3 3 0 0 0 .247 3.963l1.06 1.06a3 3 0 0 0 4.115.122l.096.037A3 3 0 0 0 15.25 28h1.5a3 3 0 0 0 3-2.948 3 3 0 0 0 4.205-.036l1.06-1.061a3 3 0 0 0 .037-4.205 3 3 0 0 0 2.948-3v-1.5a3 3 0 0 0-2.826-2.995l-.037-.096a3 3 0 0 0-.122-4.114l-1.06-1.06a3 3 0 0 0-3.963-.248 10 10 0 0 0-.266-.117A3 3 0 0 0 16.75 4zm-1 3a1 1 0 0 1 1-1h1.5a1 1 0 0 1 1 1v.316a1 1 0 0 0 .676.947q.658.225 1.259.557a1 1 0 0 0 1.19-.17l.251-.251a1 1 0 0 1 1.415 0l1.06 1.06a1 1 0 0 1 0 1.415l-.359.358a1 1 0 0 0-.194 1.14q.27.56.45 1.165a1 1 0 0 0 .959.713H25a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1h-.65a1 1 0 0 0-.946.676 8 8 0 0 1-.454 1.066 1 1 0 0 0 .182 1.165l.47.47a1 1 0 0 1 0 1.414L22.54 23.6a1 1 0 0 1-1.415 0l-.47-.47a1 1 0 0 0-1.164-.181 8 8 0 0 1-1.066.454 1 1 0 0 0-.676.946V25a1 1 0 0 1-1 1h-1.5a1 1 0 0 1-1-1v-.543a1 1 0 0 0-.713-.958 8 8 0 0 1-1.165-.45 1 1 0 0 0-1.14.194l-.359.358a1 1 0 0 1-1.414 0l-.707.707.707-.707-1.06-1.06a1 1 0 0 1 0-1.415l.252-.252a1 1 0 0 0 .169-1.189q-.332-.601-.558-1.259a1 1 0 0 0-.946-.676H7a1 1 0 0 1-1-1v-1.5a1 1 0 0 1 1-1h.21a1 1 0 0 0 .957-.713q.214-.713.55-1.362a1 1 0 0 0-.182-1.165l-.136-.136a1 1 0 0 1 0-1.415l1.06-1.06a1 1 0 0 1 1.414 0l.137.136a1 1 0 0 0 1.165.182 8 8 0 0 1 1.362-.55 1 1 0 0 0 .713-.957zM19 16a3 3 0 1 1-6 0 3 3 0 0 1 6 0m2 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCog32);
